import style from "../style";
import { robotFront } from "../assets";


import { motion } from "framer-motion";

const Hero = () => {
    return (
        <section id="home" className={`flex md:flex-row flex-col ${style.paddingY} mt-20`}>
            <motion.div
                initial={{ x: -100, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
                className={`flex-1 ${style.flexStart} flex-col xl:px-0 sm:px-16 px-6`}
            >
                <motion.div
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ delay: 0.2, duration: 0.5 }}
                    className="flex flex-row items-center py-[6px] px-4 bg-slate-100 rounded-[10px] mb-2 border border-slate-200"
                >
                    <p className={`${style.paragraph} ml-2 text-sm uppercase tracking-[2px] text-slate-500`}>
                        <span className="text-slate-900 font-bold">PROYECTO</span> DE{" "}
                        <span className="text-slate-900 font-bold">INVESTIGACIÓN</span> Y{" "}
                        <span className="text-slate-900 font-bold">DESARROLLO</span>{""}
                    </p>
                </motion.div>

                <div className="flex flex-row justify-between items-center w-full">
                    <h1 className="flex-1 font-poppins font-bold ss:text-[72px] text-[52px] text-darkBlue ss:leading-[100.8px] leading-[75px]">
                        Vehículo <br className="sm:block hidden" />{" "}
                        <span className="text-gradient">Autónomo</span>{"  "}
                    </h1>
                </div>

                <h1 className="font-poppins font-bold ss:text-[68px] text-[52px] text-darkBlue ss:leading-[100.8px] leading-[75px] w-full">
                    de Exploración.
                </h1>

                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.5, duration: 1 }}
                >
                    <p className={"text-secondary font-semibold tracking-[3px] mt-2"}>{"PROTOTIPO EN DESARROLLO"}</p>
                    <p className={`${style.paragraph} max-w-[470px] mt-5 leading-[1.6]`}>
                        EL Vehículo Autónomo de Exploración (VAE) está equipado con cámaras para operaciones de exploración y reconocimiento. Puede ser
                        fácilmente desplegado en el terreno, pudiendo cumplir misiones de forma autónoma o controlado a
                        distancia mediante su unidad de control.
                    </p>

                    <button className="mt-10 px-8 py-4 bg-blue-gradient font-poppins font-semibold text-[18px] text-white outline-none rounded-[10px] hover:scale-105 transition-all shadow-lg shadow-blue-500/20 active:scale-95">
                        Saber más
                    </button>
                </motion.div>
            </motion.div>

            <motion.div
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 1, ease: "easeOut" }}
                className={`flex-1 flex ${style.flexCenter} md:my-0 my-10 relative`}
            >
                <div className="relative w-full max-w-[600px] aspect-square flex justify-center items-center">
                    <img
                        src={robotFront}
                        alt="VAE Robot"
                        className="w-full h-full object-contain relative z-[5] mix-blend-multiply opacity-95"
                        style={{
                            maskImage: 'radial-gradient(circle, black 65%, transparent 100%)',
                            WebkitMaskImage: 'radial-gradient(circle, black 65%, transparent 100%)'
                        }}
                    />
                </div>
            </motion.div>
        </section>
    );
};

export default Hero;
